module.exports = __webpack_public_path__ + "static/media/LegacyPreciousMetalsLogo.6a58c46c.png";